import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import MainLoader from '../../../components/Loaders/MainLoader';
import BtnContent from '../../../components/buttons/BtnContent';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import Error from '../../../components/errors/Error';
//SLICES
import EditorForm from '../../../components/Inputs/formInput/EditorForm';
import { getPoliticThunk, initialStatePolitic, createPoliticThunk, updatePoliticThunk } from '../../../store/slices/catalogs/politics.slice';



const PolicyForm = () => {
    const { t } = useTranslation();
    let { policy_id } = useParams();
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { handleSubmit, formState: { errors } } = useForm();
    const { item, message, error } = useSelector(state => state.politics);
    const isLoading = useSelector(state => state.isLoadingSlice);
    
    const [text, setText] = useState("")


    useEffect(() => {
        if (policy_id) {
            dispatch(getPoliticThunk(policy_id));
        }
        return () => {
            dispatch(initialStatePolitic());
        };
    }, []);

    useEffect(() => {
        setText(item.content)
    }, [item]);

    const onSubmit = (data) => {
        data.name = 'Politicas de Privacidad - Establecimiento'
        data.content = text
        if (policy_id) {
            dispatch(updatePoliticThunk(policy_id, data));
        } else {
            dispatch(createPoliticThunk(data));
        }
    };

    if (message === "Registro creado correctamente " || message === "Registro actualizado correctamente ") {
        navigate(`/panel/privacy_policy`);
    }

    const handleChange = (content) => {
        setText(content);
    };

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className="w-[96%] mt-5 ml-5 ">
                    {error ? <Error state={error} /> : " "}
                    <HeaderForm title={"Politica de privacidad"} />
                    <div className='h-[90%]'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='w-full'>
                                <EditorForm
                                    id={"text_one"}
                                    label={"Texto"}
                                    spam={true}
                                    cols={1}
                                    onChange={handleChange}
                                    initialValue={text}
                                />
                            </div>
                            <div className="flex items-center justify-start py-5 gap-2 border-t-2 border-orange-500 mt-8">
                                <BtnContent type="submit">{t("save_button")}</BtnContent>
                                <BtnContent cancel={true} to={`/panel/privacy_policy`}>{t("canceled_button")}</BtnContent>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default PolicyForm;